import { CSSProperties, FC } from 'react';

import { ICON_SVG_COMPONENT } from './IconSvg.const';
import { IconSvgName } from './IconSvg.types';

export interface IconSvgProps {
  name: IconSvgName;
  width?: number;
  height?: number;
  aspectRation?: CSSProperties['aspectRatio'];
}

export const IconSvg: FC<IconSvgProps> = ({
  name,
  width,
  height,
  aspectRation,
}) => {
  const Component = ICON_SVG_COMPONENT[name];

  return (
    <Component width={width} height={height} aspectRation={aspectRation} />
  );
};
